import React from 'react';
//, {useState, useEffect}
import { Route, Routes, useParams} from "react-router-dom";
import {Container} from 'react-bootstrap';
//import Sidebar from '../components/Sidebar';
//import axios from 'axios';
//import {apiUrl} from '../util/Api';
import AccountForm from './AccountForm';
import AccountList from './AccountList';
import AccountDetail from './AccountDetail';
import NotFound from '../../components/NotFound';
import LeftNav from '../../components/LeftNav';
//import {isAuthenticated} from '../../util/Auth';

//TODO: need to figure out how to handle in new system
//may have to put under settings

const Accounts = () => {
  //console.log('Accounts: ' + (new Date()).toLocaleTimeString())
  //can add exact={true} to / as well
  let {accountKey} = useParams();

  return (
    <Container fluid>
      <LeftNav accountKey={accountKey}/>
      <Routes>
        <Route path="/add" element={<AccountForm/>} />
        <Route path="/detail" element={<AccountDetail/>} />
        <Route path="/list" element={<AccountList/>} exact={true}/>
        <Route path="/" element={<AccountDetail/>} />
        <Route path="*" element={<NotFound/>}  />
      </Routes>

    </Container>
  )
}

export default Accounts;
